import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { PaperToastElement } from '@polymer/paper-toast/paper-toast';
import { logError } from '../helpers/api/api';

@customElement('error-toast')
export class ErrorToastElement extends LitElement {
    @query('#toast')
    toastElement!: PaperToastElement;

    @property({ type: String })
    text = '';

    async tryOrErrorToast<R>(
        func: (() => Promise<R>) | (() => R),
        message: string,
        appendError: boolean = true
    ) {
        try {
            return await Promise.resolve(func());
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const text = `${message}  ${appendError ? e : ''}`;
            this.text = text;
            this.toastElement.open();
            console.error(text);
            throw e;
        }
    }

    tryOrErrorToastSync<R>(func: () => R, message: string, appendError: boolean = true) {
        try {
            return func();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const text = `${message}  ${appendError ? e : ''}`;
            this.text = text;
            this.toastElement.open();
            console.error(text);
            throw e;
        }
    }

    showToastAndThrow(message: string): never {
        this.text = message;
        this.toastElement.open();
        logError(message);
        throw new Error(message);
    }

    showToast(message: string) {
        this.text = message;
        this.toastElement.open();
    }

    render() {
        return html`
            <div role="alert" aria-live="assertive" aria-atomic="true">
                <paper-toast id="toast" text="${this.text}"></paper-toast>
            </div>
        `;
    }

    static get styles() {
        return css``;
    }
}
